<section aria-labelledby="head-office-address" class="d-flex flex-column gap-4" *ngIf="form">
  <h3 id="head-office-address" class="section-header" i18n>Head Office Address</h3>
  <app-international-address-form-grid
    controlIdPrefix="headOfficeAddress"
    [form]="form"
    [formSubmitted]="formSubmitted" />
</section>
